import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  Inject, Input,
} from '@angular/core';
import {FormBuilder, FormGroup, FormArray, Validators, ValidationErrors} from '@angular/forms';
import {HttpService, ProjectDescription} from '../../../core';
import {ProjectService} from '../../../core/services/project.service';
import {UserService} from '../../../core/services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {TabService} from '../../../core/services/tab.service';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
// import {DeleteDialogComponent} from './delete-dialog/delete-dialog.component';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {Observable} from 'rxjs';
import {BaseComponent} from '../../../shared/components/base/base.component';
import {StatusDialogComponent} from './permission/status-dialog/status-dialog.component';
import {debounceTime, finalize} from 'rxjs/operators';


/**
 * @author Damon Gao
 * @description compare max price and min price
 * @param group FormGroup
 */
export function comparePrice(group: FormGroup): ValidationErrors | null {
  const minPrice = group.get('minPrice').value;
  const maxPrice = group.get('maxPrice').value;

  if (minPrice == null || maxPrice == null || isNaN(minPrice) || isNaN(maxPrice)) {
    return null;
  }

  if (maxPrice === 0) {
    return null;
  }


  if (maxPrice >= minPrice) {
    return null;
  } else {
    return {priceMismatch: true};
  }

}

@Component({
  selector: 'app-edit-project',
  templateUrl: './edit-project.component.html',
  styleUrls: ['./edit-project.component.scss'],
})
export class EditProjectComponent extends BaseComponent implements OnInit {
  @Input() isPackage: any;
  @Input() landProjectId: any;
  geoCoder: any;
  selectedLat: any;
  selectedLng: any;
  highestRole: any;
  reactiveForm: FormGroup;
  isSubmitted: any;

  projectId: any;
  project: any;
  projectStatus: any;
  projectType: any;

  startTimestamp = '';
  endTimestamp = '';
  sunsetTimestamp = '';
  tabIndex: number;

  selectedUsers = [];
  selectedUserIds = [];

  isUpdating: any;
  companyId: any;

  tags = [];
  indoorFeatures = [];
  outdoorFeatures = [];
  energyFeatures = [];
  publicFeatures = [];
  selectedFeatureIdArray = [];

  isLoading: boolean;
  showError = false;

  onlyNumberRegex = /^[0-9]*$/;

  private incentive = new Array(5);
  isGenerating = false;
  history: string[] = [];
  debouncePeriod = 1000;
  lastEditTime = Date.now();
  isDraft = false;
  isCreating: boolean;
  ptypeShow = false;
  pstatusShow = false;
  pnameShow = false;

  @Output() cancelEdit = new EventEmitter();
  @Output() closeDialogEvent = new EventEmitter();
  priceType = [
    {
      name: 'any', value: 0
    }, {
      name: '1', value: 1
    }, {
      name: '2', value: 2
    }, {
      name: '3', value: 3
    }, {
      name: '4', value: 4
    }, {
      name: '5+', value: 5
    }
  ];

  public style =
    'padding: 12px 10px; border: 0; width: calc(100% - 20px); outline: none; borderRadius: 4px;';

  constructor(
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private http: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private toastrService: ToastrService,
    private userService: UserService,
    public tabService: TabService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe
  ) {
    super();
    // this.reactiveForm = this.cloneFormGroup(this.reactiveForm);
    this.isLoading = true;
    this.projectStatus = [
      // {
      //   name: 'Off market',
      //   value: 1,
      // },
      {
        name: 'Off the plan',
        value: 2,
      },
      {
        name: 'Under construction',
        value: 3,
      },
      {
        name: 'Complete',
        value: 4,
      },
    ];

    this.projectType = [
      {
        name: 'House',
        value: 1,
      },
      {
        name: 'Townhouse',
        value: 2,
      },
      {
        name: 'Apartment',
        value: 3,
      },
      {
        name: 'Land',
        value: 4,
      },
    ];

    this.userService.currentUser.subscribe((user: any) => {
      this.highestRole = user.roles[0];
      this.reactiveForm = this.formBuilder.group({
          pname: [''],
          ptype: [''],
          website: [''],
          totalUnit: [''],
          level: [''],
          vrURLs: [''],
          videoURL: [''],
          introductionEN: ['', [Validators.maxLength(2000)]],
          introductionZH: ['', [Validators.maxLength(2000)]],
          addressLine1: [''],
          // addressLine2: [''],
          area: [{value: '', disabled: true}],
          city: [{value: '', disabled: true}],
          state: [{value: '', disabled: true}],
          postCode: [{value: '', disabled: true}],
          country: [{value: '', disabled: true}],
          // status: [''],
          firb: [''],
          commission: ['', [Validators.pattern(this.onlyNumberRegex)]],
          commissionUnit: [{value: '%', disabled: false}],
          pstatus: [''],
          startDate: [{value: '', disabled: true}],
          endDate: [{value: '', disabled: true}],
          sunsetDate: [{value: '', disabled: true}],
          projectStatus: [''],
          incentive1: [{value: '', disabled: false}],
          incentive2: [{value: '', disabled: false}],
          incentive3: [{value: '', disabled: false}],
          incentive4: [{value: '', disabled: false}],
          incentive5: [{value: '', disabled: false}],
          tags: [''],
          cityCouncil: [''],
          lat: [''],
          lng: [''],
          maxPrice: ['', [Validators.min(-1)]],
          minPrice: ['', [Validators.min(-1)]],
          maxTotalArea: ['', [Validators.min(-1)]],
          minTotalArea: ['', [Validators.min(-1)]],
          maxBathRoom: [0, [Validators.min(-1)]],
          minBathRoom: [0, [Validators.min(-1)]],
          maxBedRoom: [0, [Validators.min(-1)]],
          minBedRoom: [0, [Validators.min(-1)]],
          maxParking: [0, [Validators.min(-1)]],
          minParking: [0, [Validators.min(-1)]],
          sendAgentsEmails: [true],
          buildings: this.formBuilder.array([], [Validators.maxLength(10)]),
        },
        {validators: comparePrice}
      );
    });
    this.reactiveForm.get('introductionEN').valueChanges.pipe(
      debounceTime(this.debouncePeriod)
    ).subscribe((value) => {
      if (Date.now() - this.lastEditTime > this.debouncePeriod) {
        this.history.push(value);
      }
      this.lastEditTime = Date.now();
    });
  }

  ngOnInit() {
    this.isDraft = this.data.draft;
    console.log('----is draft----', this.isDraft);
    this.projectId = this.data.project.id; // this.route.snapshot.paramMap.get('id');
    this.userService.currentUser.subscribe((user: any) => {
      this.companyId = user.company.id;

      this.http
        .getProjectDetailByProjectId(this.projectId)
        .subscribe((res: any) => {
          console.log('edit project ==== ', res);
          this.project = res.data;
          if (this.project.users) {
            this.project.users.forEach((item: any) => {
              item.email = this.userService.getEmailFromContacts(item.contacts);
            });
          }

          if (!this.project) {
            this.router.navigateByUrl('/projects');
            return;
          }

          this.userService.currentUser.subscribe((u: any) => {
            const userId = u.id;
            const allowIds = [];
            if (this.project.users) {
              this.project.users.map((allowedUser) => {
                allowIds.push(allowedUser.id);
              });
            }

            // if (
            //   allowIds.indexOf(userId) === -1 ||
            //   this.highestRole.weight < 100
            // ) {
            //   this.router.navigateByUrl("/projects").then(() => {
            //     this.toastrService.warning(
            //       "Not authorized to view or edit project " + this.project.name
            //     );
            //   });

            //   return;
            // }
          });
          if (this.project.tags) {
            this.project.tags.map((tag) => {
              this.selectedFeatureIdArray.push(tag.id);
            });
            console.log(this.selectedFeatureIdArray);
          }

          // this.cdr.detectChanges();

          const projectType = [];
          this.project.projectTypes.map((type) => {
            projectType.push(type.id);
          });
          console.log(projectType);

          this.http.getAllTagsByUser().subscribe((r: any) => {
            console.log(r);
            this.tags = r.data;
            this.indoorFeatures = r.data.filter(
              (feature) => feature.type === 1
            );
            this.outdoorFeatures = r.data.filter(
              (feature) => feature.type === 2
            );
            this.energyFeatures = r.data.filter(
              (feature) => feature.type === 3
            );
            this.publicFeatures = r.data.filter(
              (feature) => feature.type === 4
            );
          });

          this.reactiveForm.patchValue({
            pname: this.project.name,
            ptype: this.project.projectTypes[0].id,
            website: this.project.website ? this.project.website : '',
            vrURLs: this.project.vrURLs ? this.project.vrURLs : '',
            videoURL:
              this.project.videoURL && this.project.videoURL
                ? this.project.videoURL
                : '',
            totalUnit: this.project.totalUnit ? this.project.totalUnit : '',
            level: this.project.level ? this.project.level : '',
            pstatus: this.project.projectStatus,
            // status: this.project.status,
            firb: this.project.firb,
            startDate: this.project.startTime
              ? new Date(this.project.startTime)
              : '',
            endDate: this.project.endTime ? new Date(this.project.endTime) : '',
            sunsetDate: this.project.sunsetTime
              ? new Date(this.project.sunsetTime)
              : '',
            // incentive: this.project.incentive ? JSON.parse(this.project.incentive) : '',
            incentive1: this.project.incentive ? this.project.incentive[0] : '',
            incentive2: this.project.incentive ? this.project.incentive[1] : '',
            incentive3: this.project.incentive ? this.project.incentive[2] : '',
            incentive4: this.project.incentive ? this.project.incentive[3] : '',
            incentive5: this.project.incentive ? this.project.incentive[4] : '',
            commission: this.project.commissionFee
              ? this.project.commissionFee
              : '',
            commissionUnit: this.project.commissionFeeUnit
              ? this.project.commissionFeeUnit
              : '%',
            introductionEN: this.project.notes ? this.project.notes.en : '',
            introductionZH: this.project.notes ? this.project.notes.zh : '',
            // addressLine1: this.project.addressLine1 ? this.project.addressLine1 : '',
            addressLine1: this.project.addressLine2
              ? this.project.addressLine2
              : '',
            area: this.project.area,
            state: this.project.state,
            city: this.project.city,
            postCode: this.project.postCode,
            country: this.project.country,
            lat: this.project.latitude ? this.project.latitude : '',
            lng: this.project.longitude ? this.project.longitude : '',
            cityCouncil: this.project.cityCouncil
              ? this.project.cityCouncil
              : '',
            maxPrice: this.project.maxPrice ? this.project.maxPrice : 0,
            minPrice: this.project.minPrice ? this.project.minPrice : 0,
            maxTotalArea: this.project.hasOwnProperty('maxTotalArea')
              ? this.project.maxTotalArea
              : '',
            minTotalArea: this.project.hasOwnProperty('minTotalArea')
              ? this.project.minTotalArea
              : '',
            maxBathRoom: this.project.hasOwnProperty('maxBathRoom')
              ? this.project.maxBathRoom
              : '',
            minBathRoom: this.project.hasOwnProperty('minBathRoom')
              ? this.project.minBathRoom
              : '',
            maxBedRoom: this.project.hasOwnProperty('maxBedRoom')
              ? this.project.maxBedRoom
              : '',
            minBedRoom: this.project.hasOwnProperty('minBedRoom')
              ? this.project.minBedRoom
              : '',
            maxParking: this.project.hasOwnProperty('maxParking')
              ? this.project.maxParking
              : '',
            minParking: this.project.hasOwnProperty('minParking')
              ? this.project.minParking
              : '',
          });
          console.log(this.reactiveForm, 'reactiveForm');

          if (this.project.buildings) {
            this.project.buildings.map((building) => {
              this.addBuilding(building);
            });
          }
          this.isLoading = false;
        });
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onInputminTotalArea($event) {
    // console.log($event)
    if (!$event) {
      return;
    }
    const target = $event.target;
    console.log(target, 'targettarget');
    const regexp = /[0-9\bBackspace\b]/;
    target.value = target.value.replace(regexp, '');
    console.log(target.value, 'target.value');
  }

  getAddress(address: any) {
    console.log(address);
    const components = address.address_components;
    let addressLine2 = '';
    let area = '';
    let city = '';
    let state = '';
    let country = '';
    let postCode = '';
    components.forEach(
      (component: {
        long_name: string;
        short_name: string;
        types: Array<string>;
      }) => {
        if (component.types.find((type) => type === 'street_number')) {
          addressLine2 = component.long_name;
        } else if (component.types.find((type) => type === 'route')) {
          addressLine2 += ' ' + component.long_name;
        } else if (component.types.find((type) => type === 'locality')) {
          area = component.long_name;
        } else if (
          component.types.find((type) => type === 'administrative_area_level_2')
        ) {
          city = component.short_name;
        } else if (
          component.types.find((type) => type === 'administrative_area_level_1')
        ) {
          state = component.short_name;
        } else if (component.types.find((type) => type === 'country')) {
          country = component.long_name;
        } else if (component.types.find((type) => type === 'postal_code')) {
          postCode = component.long_name;
        }
      }
    );
    // console.log(address);
    this.reactiveForm.get('addressLine1').setValue(addressLine2);
    this.reactiveForm.get('area').setValue(area);
    this.reactiveForm.get('city').setValue(city);
    this.reactiveForm.get('state').setValue(state);
    this.reactiveForm.get('country').setValue(country);
    this.reactiveForm.get('postCode').setValue(postCode);
    this.getCoordinatesFromAddress(
      this.reactiveForm.get('addressLine1').value +
      ' ' +
      this.reactiveForm.get('area').value +
      ' ' +
      this.reactiveForm.get('city').value +
      ' ' +
      this.reactiveForm.get('postCode').value
    ).subscribe((coordinate: any) => {
      console.log(coordinate);
      this.selectedLat = coordinate.lat;
      this.selectedLng = coordinate.lng;
      this.reactiveForm.patchValue({
        lat: coordinate.lat,
        lng: coordinate.lng,
      });
      this.cdr.detectChanges();
      // fd.append('latitude', coordinate.lat);
      // fd.append('longitude', coordinate.lng);
    });

    this.cdr.detectChanges();
  }

  // 将起始时间转换成时间戳
  getStartDate(event) {
    this.startTimestamp = new Date(event.value).getTime().toString();
    if (this.endTimestamp && this.endTimestamp <= this.startTimestamp) {
      this.showError = true;
      this.reactiveForm.get('startDate').setValue('');
    } else {
      this.showError = false;
    }
  }

  // 将结束时间转换成时间戳
  getEndDate(event) {
    this.endTimestamp = new Date(event.value).getTime().toString();
    if (this.project.startTime && this.endTimestamp <= this.project.startTime) {
      this.showError = true;
      this.reactiveForm.get('endDate').setValue('');
    } else {
      this.showError = false;
    }
  }

  // 将sunset时间转换成时间戳
  getSunsetDate(event) {
    this.sunsetTimestamp = new Date(event.value).getTime().toString();
  }

  onSubmit() {
    this.dataMinValidation('minParking', 'maxParking');
    this.dataValidation('minPrice', 'maxPrice');
    this.dataValidation('minTotalArea', 'maxTotalArea');
    this.dataMinValidation('minBathRoom', 'maxBathRoom');
    this.dataMinValidation('minBedRoom', 'maxBedRoom');
    // 项目 status -2隐藏删除 -1 待验证 0禁用 1.有效
    if (this.reactiveForm.invalid) {
      return;
    }
    const fd = new FormData();
    fd.append(
      'projectTypeIds',
      this.reactiveForm.get('ptype').value.toString()
    );

    if (this.reactiveForm.get('pname').value !== this.project.name) {
      fd.append('name', this.reactiveForm.get('pname').value);
    }

    if (this.reactiveForm.get('pstatus').value !== this.project.projectStatus) {
      fd.append('projectStatus', this.reactiveForm.get('pstatus').value);
    }

    if (
      this.reactiveForm.get('commission').value !==
      this.project.commissionFee &&
      this.reactiveForm.get('commission').value
    ) {
      fd.append('commissionFee', this.reactiveForm.get('commission').value);
    }

    if (this.reactiveForm.get('firb').value !== this.project.firb) {
      fd.append('firb', this.reactiveForm.get('firb').value);
    }
    if (
      this.reactiveForm.get('website').value !== this.project.website &&
      this.reactiveForm.get('website').value
    ) {
      fd.append('website', this.reactiveForm.get('website').value);
    }

    if (this.reactiveForm.get('totalUnit').value !== this.project.totalUnit) {
      fd.append('totalUnit', this.reactiveForm.get('totalUnit').value);
    }

    if (
      this.reactiveForm.get('commissionUnit').value !==
      this.project.commissionFeeUnit
    ) {
      fd.append(
        'commissionFeeUnit',
        this.reactiveForm.get('commissionUnit').value
      );
    }

    if (this.reactiveForm.get('level').value !== this.project.level) {
      fd.append('level', this.reactiveForm.get('level').value);
    }

    if (this.reactiveForm.get('vrURLs').value !== this.project.vrURLs) {
      fd.append('vrURLs', this.reactiveForm.get('vrURLs').value);
    }

    if (this.reactiveForm.get('videoURL').value !== this.project.videoURL) {
      fd.append('videoURL', this.reactiveForm.get('videoURL').value);
    }

    // if (this.reactiveForm.get('introductionEN').value !== this.project.notes.en || this.reactiveForm.get('introductionZH').value !== this.project.notes.zh) {
    fd.append(
      'notes',
      JSON.stringify({
        zh: this.reactiveForm.get('introductionZH').value,
        en: this.reactiveForm.get('introductionEN').value,
      })
    );
    // }

    // if (this.selectedLat && this.selectedLat !== this.project.latitude) {
    fd.append('latitude', this.reactiveForm.get('lat').value);
    // }

    // if (this.selectedLng && this.selectedLng !== this.project.longitude) {
    fd.append('longitude', this.reactiveForm.get('lng').value);
    // }
    console.log(this.project.startTime);
    console.log(this.reactiveForm.get('startDate').value);
    if (
      this.reactiveForm.get('startDate').value &&
      this.reactiveForm.get('startDate').value.getTime() !==
      this.project.startTime
    ) {
      fd.append(
        'startTime',
        this.reactiveForm.get('startDate').value.getTime().toString()
      );
    }

    console.log('endDate=========', this.reactiveForm.get('endDate').value._d);
    if (
      this.reactiveForm.get('endDate').value &&
      this.reactiveForm.get('endDate').value.getTime() !== this.project.endTime
    ) {
      fd.append(
        'endTime',
        this.reactiveForm.get('endDate').value._d.getTime().toString()
      );
    }

    if (
      this.reactiveForm.get('sunsetDate').value &&
      this.reactiveForm.get('sunsetDate').value.getTime() !==
      this.project.sunsetTime
    ) {
      fd.append(
        'sunsetTime',
        this.reactiveForm.get('sunsetDate').value.getTime().toString()
      );
    }

    if (this.reactiveForm.get('cityCouncil').value) {
      fd.append('cityCouncil', this.reactiveForm.get('cityCouncil').value);
    }

    if (this.reactiveForm.get('maxPrice').value !== this.project.maxPrice) {
      this.reactiveForm.get('maxPrice').value === null
        ? fd.append('maxPrice', '-1')
        : fd.append('maxPrice', this.reactiveForm.get('maxPrice').value);
    }
    if (this.reactiveForm.get('minPrice').value !== this.project.minPrice) {
      this.reactiveForm.get('minPrice').value === null
        ? fd.append('minPrice', '-1')
        : fd.append('minPrice', this.reactiveForm.get('minPrice').value);
    }
    if (
      this.reactiveForm.get('maxTotalArea').value !== this.project.maxTotalArea
    ) {
      this.reactiveForm.get('maxTotalArea').value === null
        ? fd.append('maxTotalArea', '-1')
        : fd.append(
          'maxTotalArea',
          this.reactiveForm.get('maxTotalArea').value
        );
    }
    if (
      this.reactiveForm.get('minTotalArea').value !== this.project.minTotalArea
    ) {
      this.reactiveForm.get('minTotalArea').value === null
        ? fd.append('minTotalArea', '-1')
        : fd.append(
          'minTotalArea',
          this.reactiveForm.get('minTotalArea').value
        );
    }
    if (this.reactiveForm.get('maxBedRoom').value !== this.project.maxBedRoom) {
      this.reactiveForm.get('maxBedRoom').value === null
        ? fd.append('maxBedRoom', '-1')
        : fd.append('maxBedRoom', this.reactiveForm.get('maxBedRoom').value);
    }
    if (this.reactiveForm.get('minBedRoom').value !== this.project.minBedRoom) {
      this.reactiveForm.get('minBedRoom').value === null
        ? fd.append('minBedRoom', '-1')
        : fd.append('minBedRoom', this.reactiveForm.get('minBedRoom').value);
    }
    if (
      this.reactiveForm.get('maxBathRoom').value !== this.project.maxBathRoom
    ) {
      this.reactiveForm.get('maxBathRoom').value === null
        ? fd.append('maxBathRoom', '-1')
        : fd.append('maxBathRoom', this.reactiveForm.get('maxBathRoom').value);
    }
    if (
      this.reactiveForm.get('minBathRoom').value !== this.project.minBathRoom
    ) {
      this.reactiveForm.get('minBathRoom').value === null
        ? fd.append('minBathRoom', '-1')
        : fd.append('minBathRoom', this.reactiveForm.get('minBathRoom').value);
    }
    if (this.reactiveForm.get('maxParking').value !== this.project.maxParking) {
      this.reactiveForm.get('maxParking').value === null
        ? fd.append('maxParking', '-1')
        : fd.append('maxParking', this.reactiveForm.get('maxParking').value);
    }
    if (this.reactiveForm.get('minParking').value !== this.project.minParking) {
      this.reactiveForm.get('minParking').value === null
        ? fd.append('minParking', '-1')
        : fd.append('minParking', this.reactiveForm.get('minParking').value);
    }

    // fd.append('startTime', this.startTimestamp this.reactiveForm.get('startDate').value);
    // fd.append('endTime', this.endTimestamp);
    // fd.append('sunsetTime', this.sunsetTimestamp);

    const length = this.incentive.length;
    for (let i = 0; i < length; i++) {
      const value = this.reactiveForm.get('incentive' + (i + 1)).value;
      if (value) {
        this.incentive[i] = value;
      }
    }
    const hasIncentive =
      this.incentive.filter((i) => {
        return i !== null;
      }).length > 0;
    console.log(hasIncentive, this.incentive);
    // if (hasIncentive) {
    fd.append('incentive', JSON.stringify(this.incentive));
    // }

    if (
      this.reactiveForm.get('addressLine1').value !== this.project.addressLine2
    ) {
      fd.append('addressLine2', this.reactiveForm.get('addressLine1').value);
    }

    // if (this.reactiveForm.get('addressLine2').value !== this.project.addressLine2) {
    //   fd.append('addressLine2', this.reactiveForm.get('addressLine2').value);
    // }

    if (this.reactiveForm.get('postCode').value !== this.project.postCode) {
      fd.append('postCode', this.reactiveForm.get('postCode').value);
    }

    if (this.reactiveForm.get('area').value !== this.project.area) {
      fd.append('area', this.reactiveForm.get('area').value);
    }

    if (this.reactiveForm.get('city').value !== this.project.city) {
      fd.append('city', this.reactiveForm.get('city').value);
    }

    if (this.reactiveForm.get('state').value !== this.project.state) {
      fd.append('state', this.reactiveForm.get('state').value);
    }

    if (this.reactiveForm.get('country').value !== this.project.country) {
      fd.append('country', this.reactiveForm.get('country').value);
    }

    if (this.selectedUserIds.length > 0) {
      fd.append('userIds', this.selectedUserIds.toString());
    }

    // fd.append('status', this.reactiveForm.get('status').value);

    fd.append('tagIds', this.selectedFeatureIdArray.toString());

    const buildings = this.reactiveForm.get('buildings').value;
    // 删除building
    if (this.project.buildings) {
      this.project.buildings.forEach((building) => {
        if (!buildings.find((b) => b.id === building.id)) {
          this.http.deleteProject(building.id).subscribe((r: any) => {
            console.log(r);
            if (r.code === 0) {
              this.toastrService.error('Failed to delete building.');
            }
          });
        }
      });
    }

    if (buildings.length > 0) {
      buildings.forEach((building) => {
        if (building.id) {
          // 修改

          if (
            building.name !=
            this.project.buildings.find((b) => b.id === building.id).name
          ) {
            const editFd = new FormData();
            editFd.append('name', building.name);
            this.http.updateProject(editFd, building.id).subscribe((r: any) => {
              console.log(r);
              if (r.code === 0) {
                this.toastrService.error('Failed to create building.');
              }
            });
          }
        } else {
          // 创建
          console.log('create building');
          const newFd = new FormData();
          newFd.append('name', building.name);
          newFd.append(
            'projectTypeIds',
            this.reactiveForm.get('ptype').value.toString()
          );
          newFd.append('projectStatus', this.reactiveForm.get('pstatus').value);
          newFd.append('firb', this.reactiveForm.get('firb').value);
          newFd.append('buildingProjectId', this.projectId);
          newFd.append('latitude', this.reactiveForm.get('lat').value);
          newFd.append('longitude', this.reactiveForm.get('lng').value);
          newFd.append('addressLine1', this.project.addressLine1 || '');
          newFd.append('addressLine2', this.project.addressLine2 || '');
          newFd.append('area', this.project.area);
          newFd.append('city', this.project.city);
          newFd.append('country', this.project.country);
          newFd.append('postCode', this.project.postCode);
          newFd.append('state', this.project.state);

          newFd.append('companyId', this.companyId);

          this.http.createProject(newFd).subscribe((r: any) => {
            console.log(r);
            if (r.code === 0) {
              this.toastrService.error('Failed to create building.');
            }
          });
        }
      });
    }

    this.isUpdating = true;
    this.http.updateProject(fd, this.project.id).subscribe((r: any) => {
      console.log(r);
      if (r.code === 1) {
        this.project = r.data;
        this.projectService.projects = null;
        this.toastrService.success('Project updating successful.');

        // 跳转回project详情
        // this.router.navigateByUrl('/projects/' + this.project.id)
        this.isUpdating = false;

        // 刷新当前页面
        window.location.reload();
      } else if (r.code === 0) {
        this.toastrService.error(
          'Because the project is ' +
          (this.project.status === 0 ? 'deactivated' : 'being verified'),
          'Failed to update project.'
        );
        this.isUpdating = false;
      }
    });
  }

  aaa(e) {
    console.log(e);
  }

  cancelEditClick() {
    this.cancelEdit.emit();
  }

  openDeleteDialog() {
    const dialogRef = this.dialog.open(StatusDialogComponent, {
      data: {
        project: this.project,
        targetStatus: -2,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.result.code === 1) {
        window.location.replace('/console/developer/projects');
      }
    });
  }

  isCheckBoxSelected(productId: number) {
    return this.selectedFeatureIdArray.includes(productId);
  }

  select(event: MatCheckboxChange, productId) {
    console.log(this.tags);
    if (event.checked) {
      this.selectedFeatureIdArray.push(productId);
      // if (this.selectedProductIdArray.length >= 2) {
      //     this.canCombine = true;
      // }
    } else {
      const index = this.selectedFeatureIdArray.indexOf(productId);
      this.selectedFeatureIdArray.splice(index, 1);
      // if (this.selectedProductIdArray.length < 2) {
      //     this.canCombine = false;
      // }
    }
    console.log(this.selectedFeatureIdArray);
  }

  public getCoordinatesFromAddress(address) {
    this.geoCoder = new google.maps.Geocoder();
    return new Observable((observer) => {
      this.geoCoder.geocode({address}, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          // // console.log(results[0].geometry.location)
          observer.next({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          });
        } else {
          // // console.log('Error - ', results, ' & Status - ', status);
          observer.next({lat: 0, lng: 0});
        }
        observer.complete();
      });
    });
  }

  dataValidation(min, max) {
    if (max === 'maxPrice') {
      if (this.reactiveForm.get(max).value === 0) {
        this.reactiveForm.get(max).setErrors(null);
      } else {
        this.reactiveForm.get(max).setErrors({incorrect: true});
      }
    } else if (
      this.reactiveForm.get(min).value !== '' &&
      this.reactiveForm.get(max).value !== '' &&
      this.reactiveForm.get(min).value !== null &&
      this.reactiveForm.get(max).value !== null &&
      this.reactiveForm.get(max).value < this.reactiveForm.get(min).value
    ) {
      this.reactiveForm.get(max).setErrors({incorrect: true});
    } else {
      this.reactiveForm.get(max).setErrors(null);
    }
  }

  dataMinValidation(min, max) {
    if (this.reactiveForm.get(min).value !== 0 && this.reactiveForm.get(max).value !== 0 && this.reactiveForm.get(min).value !== null && this.reactiveForm.get(max).value !== null && this.reactiveForm.get(max).value < this.reactiveForm.get(min).value) {
      this.reactiveForm.get(max).setErrors({incorrect: true});
    }
  }

  newBuilding(building: any): FormGroup {
    if (building) {
      return this.formBuilder.group({
        id: building.id,
        name: building.name,
      });
    }
    return this.formBuilder.group({
      id: '',
      name: '',
    });
  }

  addBuilding(building?: any) {
    if (this.buildings.length >= 10) {
      this.toastrService.warning('You can only add 10 buildings.');
      return;
    }
    this.buildings.push(this.newBuilding(building));
  }

  removeBuilding(i: number) {
    const buildingItem = this.buildings.at(i);
    console.log(buildingItem.get('id').value);
    const building = this.project.buildings?.find(
      (b) => b.id === buildingItem.get('id').value
    );

    if (building && building.properties && building.properties.length) {
      this.toastrService.warning('Building has properties.');
      return;
    }
    this.buildings.removeAt(i);
  }

  get buildings() {
    return this.reactiveForm.get('buildings') as FormArray;
  }

  handleClearIndoor() {
    this.indoorFeatures.forEach((item) => {
      this.selectedFeatureIdArray.forEach((item1, i) => {
        if (item.id == item1) {
          this.selectedFeatureIdArray.splice(i, 1);
        }
      });
    });
  }

  handleClearPublic() {
    this.publicFeatures.forEach((item) => {
      this.selectedFeatureIdArray.forEach((item1, i) => {
        if (item.id == item1) {
          this.selectedFeatureIdArray.splice(i, 1);
        }
      });
    });
  }

  /**
   * @author Damon Gao
   * @description Undo content
   */
  undo() {
    if (this.history.length > 1) {
      this.history.pop();
      const lastValue = this.history[this.history.length - 1];
      this.reactiveForm.get('introductionEN').setValue(lastValue);
    } else {
      this.reactiveForm.get('introductionEN').setValue('');
    }
  }

  /**
   * @author Damon Gao
   * @description Generate AI description
   */
  generateAIDescription() {
    this.isGenerating = true;
    const projectStatus = this.getProjectStatus();
    const projectType = this.getProjectType();
    const data = this.collectProjectData(projectType, projectStatus);
    if (this.hasEmptyRequiredFields(data)) {
      this.toastrService.error('Please fill in the required fields.');
      this.isGenerating = false;
      return;
    }
    this.populateOptionalFields(data);
    this.createProjectDescription(data);
  }

  getProjectStatus() {
    const statusMap = {
      1: 'Off market',
      2: 'Off the plan',
      3: 'Under construction',
      4: 'Complete',
    };
    return statusMap[this.reactiveForm.get('pstatus').value];
  }

  getProjectType() {
    const typeMap = {
      1: 'House',
      2: 'Townhouse',
      3: 'Apartment',
      4: 'House & Land',
    };
    return typeMap[this.reactiveForm.get('ptype').value];
  }

  collectProjectData(projectType: string, projectStatus: string): ProjectDescription {
    return {
      project_name: this.reactiveForm.get('pname').value,
      address: this.composeAddress(),
      project_type: projectType,
      project_status: projectStatus,
    };
  }

  composeAddress() {
    return [
      this.reactiveForm.get('addressLine1').value,
      this.reactiveForm.get('area').value,
      this.reactiveForm.get('city').value,
      this.reactiveForm.get('postCode').value,
    ].join(' ');
  }

  hasEmptyRequiredFields(data: ProjectDescription) {
    return Object.values(data).some(value => value === null || value === ''
      || value === undefined);
  }

  populateOptionalFields(data: ProjectDescription) {
    const optionalFields = [
      'totalUnit', 'minPrice', 'maxPrice', 'minBedRoom', 'maxBedRoom', 'minBathRoom', 'maxBathRoom', 'minParking',
      'maxParking',
    ];
    optionalFields.forEach((field) => {
      if (this.reactiveForm.get(field).value) {
        data[field] = this.reactiveForm.get(field).value;
      }
    });
    if (this.selectedFeatureIdArray.length > 0) {
      data.project_features = this.selectedFeatureIdArray;
    }
  }

  createProjectDescription(data: ProjectDescription) {
    this.http.createProjectDescription(data)
      .pipe(finalize(() => {
        this.isGenerating = false;
      }))
      .subscribe((res: any) => {
        console.log('---ai project generation---', res);
        this.reactiveForm.get('introductionEN').setValue(res.project_description);
      });
  }

  dateValidation() {

    if (this.startTimestamp && this.endTimestamp && this.endTimestamp < this.startTimestamp) {
      this.reactiveForm.get('endDate').setErrors({incorrect: true});
    } else {
      this.reactiveForm.get('endDate').setErrors(null);
    }
  }

  onSubmitCreate() {
    this.dateValidation();
    this.dataMinValidation('minParking', 'maxParking');
    this.dataValidation('minTotalArea', 'maxTotalArea');
    this.dataMinValidation('minBathRoom', 'maxBathRoom');
    this.dataMinValidation('minBedRoom', 'maxBedRoom');
    this.ptypeShow = !this.reactiveForm.get('ptype').value;
    this.pstatusShow = !this.reactiveForm.get('pstatus').value;
    this.pnameShow = !this.reactiveForm.get('pname').value;
    this.isSubmitted = true;
    if (this.reactiveForm.invalid) {
      setTimeout(() => {
        const matdialogcontainer: any = document.getElementsByClassName('mat-dialog-container')[0];
        const container = document.getElementById('basic-info-container');
        const matError: any = container.getElementsByClassName('mat-error')[0];
        const offsetTop = matError.offsetTop - matdialogcontainer.offsetTop - 80;

        console.log(matError, matError.offsetTop, matdialogcontainer.offsetTop);
        matdialogcontainer.scrollTo(0, offsetTop);
      }, 500);
      return;
    }

    if (!this.reactiveForm.get('state').value) {
      return;
    }

    this.userService.currentUser.subscribe((user: any) => {
      this.companyId = user.company.id;
      const fd = new FormData();

      if (this.landProjectId) {
        fd.append('landProjectId', this.landProjectId);
      }

      fd.append('latitude', this.reactiveForm.get('lat').value);
      fd.append('longitude', this.reactiveForm.get('lng').value);
      fd.append('companyId', this.companyId);
      fd.append('projectTypeIds', this.reactiveForm.get('ptype').value.toString());
      fd.append('projectStatus', this.reactiveForm.get('pstatus').value);
      fd.append('name', this.reactiveForm.get('pname').value);
      fd.append('firb', this.reactiveForm.get('firb').value);
      fd.append('addressLine2', this.reactiveForm.get('addressLine1').value);
      fd.append('area', this.reactiveForm.get('area').value);
      fd.append('city', this.reactiveForm.get('city').value);
      fd.append('postCode', this.reactiveForm.get('postCode').value);
      fd.append('state', this.reactiveForm.get('state').value);
      fd.append('country', this.reactiveForm.get('country').value);

      if (this.reactiveForm.get('introductionEN').value || this.reactiveForm.get('introductionZH').value) {
        fd.append('notes', JSON.stringify({
          zh: this.reactiveForm.get('introductionZH').value,
          en: this.reactiveForm.get('introductionEN').value,
        }));
      }

      if (this.reactiveForm.get('commission').value) {
        console.log(this.reactiveForm.get('commission').value);
        fd.append('commissionFee', this.reactiveForm.get('commission').value);
      }

      if (this.reactiveForm.get('commissionUnit').value) {
        console.log(this.reactiveForm.get('commissionUnit').value);
        fd.append('commissionFeeUnit', this.reactiveForm.get('commissionUnit').value);
      }

      if (this.reactiveForm.get('website').value) {
        fd.append('website', this.reactiveForm.get('website').value);
      }

      if (this.reactiveForm.get('totalUnit').value) {
        fd.append('totalUnit', this.reactiveForm.get('totalUnit').value);
      }
      if (this.reactiveForm.get('level').value) {
        fd.append('level', this.reactiveForm.get('level').value);
      }
      if (this.startTimestamp) {
        fd.append('startTime', this.startTimestamp);
      }
      if (this.endTimestamp) {
        fd.append('endTime', this.endTimestamp);
      }
      if (this.sunsetTimestamp) {
        fd.append('sunsetTime', this.sunsetTimestamp);
      }

      if (this.selectedUserIds.length > 0) {
        fd.append('userIds', this.selectedUserIds.toString());
      }

      if (this.selectedFeatureIdArray.length > 0) {
        fd.append('tagIds', this.selectedFeatureIdArray.toString());
      }

      if (this.reactiveForm.get('cityCouncil').value) {
        fd.append('cityCouncil', this.reactiveForm.get('cityCouncil').value);
      }

      if (this.reactiveForm.get('maxPrice').value) {
        fd.append('maxPrice', this.reactiveForm.get('maxPrice').value);
      }

      if (this.reactiveForm.get('minPrice').value) {
        fd.append('minPrice', this.reactiveForm.get('minPrice').value);
      }
      if (this.reactiveForm.get('maxTotalArea').value) {
        fd.append('maxTotalArea', this.reactiveForm.get('maxTotalArea').value);
      }

      if (this.reactiveForm.get('minTotalArea').value) {
        fd.append('minTotalArea', this.reactiveForm.get('minTotalArea').value);
      }
      if (this.reactiveForm.get('maxBathRoom').value) {
        fd.append('maxBathRoom', this.reactiveForm.get('maxBathRoom').value);
      } else {
        fd.append('maxBathRoom', '0');
      }

      if (this.reactiveForm.get('minBathRoom').value || this.reactiveForm.get('minBathRoom').value === 0) {
        fd.append('minBathRoom', this.reactiveForm.get('minBathRoom').value);
      } else {
        fd.append('minBathRoom', '0');
      }
      if (this.reactiveForm.get('maxBedRoom').value) {
        fd.append('maxBedRoom', this.reactiveForm.get('maxBedRoom').value);
      } else {
        fd.append('maxBedRoom', '0');
      }

      if (this.reactiveForm.get('minBedRoom').value || this.reactiveForm.get('minBedRoom').value === 0) {
        fd.append('minBedRoom', this.reactiveForm.get('minBedRoom').value);
      } else {
        fd.append('minBedRoom', '0');
      }
      if (this.reactiveForm.get('maxParking').value) {
        fd.append('maxParking', this.reactiveForm.get('maxParking').value);
      } else {
        fd.append('maxParking', '0');
      }

      if (this.reactiveForm.get('minParking').value || this.reactiveForm.get('minParking').value === 0) {
        fd.append('minParking', this.reactiveForm.get('minParking').value);
      } else {
        fd.append('minParking', '0');
      }
      const length = this.incentive.length;
      for (let i = 0; i < length; i++) {
        const value = this.reactiveForm.get('incentive' + (i + 1)).value;
        if (value) {
          this.incentive[i] = value;
        }
      }

      const hasIncentive = this.incentive.filter((i) => {
        return i !== null;
      }).length > 0;
      if (hasIncentive) {
        fd.append('incentive', JSON.stringify(this.incentive));
      }
      this.isCreating = true;
      fd.append('sendAgentsEmails', this.reactiveForm.get('sendAgentsEmails').value);
      this.http.deleteDraftProject(this.projectId)
        .subscribe((res: any) => {
          if (res.code !== 1) {
            this.toastrService.error('Failed to delete draft project.');
          }
        });
      this.http.createProject(fd).subscribe((r: any) => {
        console.log(r);
        if (r.code === 1) {
          // if is land, do not create building
          if (this.reactiveForm.get('ptype').value === '4') {
            this.projectService.projects.push(r.data);
            this.toastrService.success('Project creation successful.');
            this.isCreating = false;
            this.router.navigateByUrl('/projects');
            console.log('created land');
          } else {
            // 创建 building
            const buildings = this.reactiveForm.get('buildings').value;
            if (buildings.length > 0) {
              buildings.forEach((building) => {

                console.log('create building');
                const fd = new FormData();
                fd.append('name', building.name);
                fd.append('projectTypeIds', this.reactiveForm.get('ptype').value.toString());
                fd.append('projectStatus', this.reactiveForm.get('pstatus').value);
                fd.append('firb', this.reactiveForm.get('firb').value);
                fd.append('buildingProjectId', r.data.id);
                fd.append('latitude', this.reactiveForm.get('lat').value);
                fd.append('longitude', this.reactiveForm.get('lng').value);
                fd.append('addressLine1', r.data.addressLine1 || '');
                fd.append('addressLine2', r.data.addressLine2 || '');
                fd.append('area', r.data.area);
                fd.append('city', r.data.city);
                fd.append('country', r.data.country);
                fd.append('postCode', r.data.postCode);
                fd.append('state', r.data.state);

                fd.append('companyId', this.companyId);

                this.http.createProject(fd).subscribe((r: any) => {
                  console.log(r);
                  if (r.code === 0) {
                    this.toastrService.error('Failed to create building.');
                  }
                });

              });
            }

            if (!this.isPackage) {
              this.projectService.projects.push(r.data);
              this.toastrService.success('Project creation successful.');
              this.isCreating = false;
              this.router.navigateByUrl('/projects');
            } else {
              console.log('closeDialogEvent.emit');
              this.toastrService.success('Package creation successful.');
              this.closeDialogEvent.emit({code: 1, data: r.data});
            }

            console.log('created building');
          }

        } else {
          this.toastrService.error('Project creation failed.');
          this.isCreating = false;
          this.cdr.detectChanges();
        }

        this.dialogRef.close();
        window.location.reload();
        console.log('dialogRef.close()');
      });
    });
  }

  onSaveDraft() {
    this.isCreating = true;
    this.dateValidation();
    this.dataMinValidation('minParking', 'maxParking');
    this.dataValidation('minTotalArea', 'maxTotalArea');
    this.dataMinValidation('minBathRoom', 'maxBathRoom');
    this.dataMinValidation('minBedRoom', 'maxBedRoom');
    this.reactiveForm.patchValue({
      pstatus: '5',
    });
    this.ptypeShow = !this.reactiveForm.get('ptype').value;
    this.pstatusShow = !this.reactiveForm.get('pstatus').value;
    this.pnameShow = !this.reactiveForm.get('pname').value;
    const firbValue = this.reactiveForm.get('firb').value;
    if (firbValue === '' || firbValue === undefined) {
      this.reactiveForm.get('firb').setValue('1');
    }
    this.isSubmitted = true;
    if (this.reactiveForm.invalid) {
      setTimeout(() => {
        const matdialogcontainer: any = document.getElementsByClassName('mat-dialog-container')[0];
        const container = document.getElementById('basic-info-container');
        const matError: any = container.getElementsByClassName('mat-error')[0];
        const offsetTop = matError.offsetTop - matdialogcontainer.offsetTop - 80;

        console.log(matError, matError.offsetTop, matdialogcontainer.offsetTop);
        matdialogcontainer.scrollTo(0, offsetTop);
      }, 500);
      return;
    }

    if (!this.reactiveForm.get('state').value) {
      return;
    }

    this.userService.currentUser.subscribe((user: any) => {
      this.companyId = user.company.id;
      const fd = new FormData();

      if (this.landProjectId) {
        fd.append('landProjectId', this.landProjectId);
      }

      fd.append('latitude', this.reactiveForm.get('lat').value);
      fd.append('longitude', this.reactiveForm.get('lng').value);
      fd.append('companyId', this.companyId);
      fd.append('projectTypeIds', this.reactiveForm.get('ptype').value.toString());
      fd.append('projectStatus', '5');
      fd.append('name', this.reactiveForm.get('pname').value);
      fd.append('firb', this.reactiveForm.get('firb').value ? this.reactiveForm.get('firb').value : '1');
      fd.append('addressLine2', this.reactiveForm.get('addressLine1').value);
      fd.append('area', this.reactiveForm.get('area').value);
      fd.append('city', this.reactiveForm.get('city').value);
      fd.append('postCode', this.reactiveForm.get('postCode').value);
      fd.append('state', this.reactiveForm.get('state').value);
      fd.append('country', this.reactiveForm.get('country').value);
      fd.append('businessType', '1');
      if (this.reactiveForm.get('introductionEN').value || this.reactiveForm.get('introductionZH').value) {
        fd.append('notes', JSON.stringify({
          zh: this.reactiveForm.get('introductionZH').value,
          en: this.reactiveForm.get('introductionEN').value,
        }));
      }

      if (this.reactiveForm.get('commission').value) {
        console.log(this.reactiveForm.get('commission').value);
        fd.append('commissionFee', this.reactiveForm.get('commission').value);
      }

      if (this.reactiveForm.get('commissionUnit').value) {
        console.log(this.reactiveForm.get('commissionUnit').value);
        fd.append('commissionFeeUnit', this.reactiveForm.get('commissionUnit').value);
      }

      if (this.reactiveForm.get('website').value) {
        fd.append('website', this.reactiveForm.get('website').value);
      }

      if (this.reactiveForm.get('totalUnit').value) {
        fd.append('totalUnit', this.reactiveForm.get('totalUnit').value);
      }
      if (this.reactiveForm.get('level').value) {
        fd.append('level', this.reactiveForm.get('level').value);
      }
      if (this.startTimestamp) {
        fd.append('startTime', this.startTimestamp);
      }
      if (this.endTimestamp) {
        fd.append('endTime', this.endTimestamp);
      }
      if (this.sunsetTimestamp) {
        fd.append('sunsetTime', this.sunsetTimestamp);
      }

      if (this.selectedUserIds.length > 0) {
        fd.append('userIds', this.selectedUserIds.toString());
      }

      if (this.selectedFeatureIdArray.length > 0) {
        fd.append('tagIds', this.selectedFeatureIdArray.toString());
      }

      if (this.reactiveForm.get('cityCouncil').value) {
        fd.append('cityCouncil', this.reactiveForm.get('cityCouncil').value);
      }

      if (this.reactiveForm.get('maxPrice').value) {
        fd.append('maxPrice', this.reactiveForm.get('maxPrice').value);
      }

      if (this.reactiveForm.get('minPrice').value) {
        fd.append('minPrice', this.reactiveForm.get('minPrice').value);
      }
      if (this.reactiveForm.get('maxTotalArea').value) {
        fd.append('maxTotalArea', this.reactiveForm.get('maxTotalArea').value);
      }

      if (this.reactiveForm.get('minTotalArea').value) {
        fd.append('minTotalArea', this.reactiveForm.get('minTotalArea').value);
      }
      if (this.reactiveForm.get('maxBathRoom').value) {
        fd.append('maxBathRoom', this.reactiveForm.get('maxBathRoom').value);
      } else {
        fd.append('maxBathRoom', '0');
      }

      if (this.reactiveForm.get('minBathRoom').value || this.reactiveForm.get('minBathRoom').value === 0) {
        fd.append('minBathRoom', this.reactiveForm.get('minBathRoom').value);
      } else {
        fd.append('minBathRoom', '0');
      }
      if (this.reactiveForm.get('maxBedRoom').value) {
        fd.append('maxBedRoom', this.reactiveForm.get('maxBedRoom').value);
      } else {
        fd.append('maxBedRoom', '0');
      }

      if (this.reactiveForm.get('minBedRoom').value || this.reactiveForm.get('minBedRoom').value === 0) {
        fd.append('minBedRoom', this.reactiveForm.get('minBedRoom').value);
      } else {
        fd.append('minBedRoom', '0');
      }
      if (this.reactiveForm.get('maxParking').value) {
        fd.append('maxParking', this.reactiveForm.get('maxParking').value);
      } else {
        fd.append('maxParking', '0');
      }

      if (this.reactiveForm.get('minParking').value || this.reactiveForm.get('minParking').value === 0) {
        fd.append('minParking', this.reactiveForm.get('minParking').value);
      } else {
        fd.append('minParking', '0');
      }
      const length = this.incentive.length;
      for (let i = 0; i < length; i++) {
        const value = this.reactiveForm.get('incentive' + (i + 1)).value;
        if (value) {
          this.incentive[i] = value;
        }
      }

      const hasIncentive = this.incentive.filter((i) => {
        return i !== null;
      }).length > 0;
      if (hasIncentive) {
        fd.append('incentive', JSON.stringify(this.incentive));
      }
      this.http.updateDraftProject(fd, this.projectId).subscribe((r: any) => {
        if (r.code === 1) {
          console.log('-----draft----', r);
          this.dialogRef.close();
          this.toastrService.success('Project draft saved.');
        }
      });
    });
  }
}
